const MILLISECONDS_IN_DAY = 1000 * 3600 * 24;
export const MANDATORY_TWO_FACTOR_SEVERITY = Object.freeze({
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical'
});
export const getMandatoryTwoFactorSeverity = ({
  enforcementStartTimestamp,
  promptStartTimestamp
} = {}) => {
  if ([enforcementStartTimestamp, promptStartTimestamp].includes(undefined)) {
    return MANDATORY_TWO_FACTOR_SEVERITY.INFO;
  }
  const windowLengthInDays = Math.floor((new Date(enforcementStartTimestamp).getTime() - new Date(promptStartTimestamp).getTime()) / MILLISECONDS_IN_DAY);
  const daysUntilEnforcement = Math.floor((new Date(enforcementStartTimestamp).getTime() - Date.now()) / MILLISECONDS_IN_DAY);
  const daysLeftRatio = daysUntilEnforcement / windowLengthInDays;
  if (daysLeftRatio >= 2 / 3) {
    return MANDATORY_TWO_FACTOR_SEVERITY.INFO;
  } else if (daysLeftRatio < 2 / 3 && daysLeftRatio >= 1 / 3) {
    return MANDATORY_TWO_FACTOR_SEVERITY.WARNING;
  } else {
    return MANDATORY_TWO_FACTOR_SEVERITY.CRITICAL;
  }
};